$(document).ready(function (){
  $('#target_variant_id').change(function() {
    var selected_target    = $(this).val()
    var origin_variant_ids = `${$('#tmp_origin_variant_ids').data('origin-variant-ids')}`

    flashMessage()
    GetInventoryVariant(selected_target, origin_variant_ids)
  }).change()

  function flashMessage() {
    var notice = `<div class="alert alert-success">`+
                  `<span class="close" data-dismiss="alert">×</span>`+
                  I18n.t('global.processing')+
                 `</div>`;

    $('.flash-messages').html(notice)
  }

  function GetInventoryVariant(selected_target, origin_variant_ids) {
    $.ajax({
      type: "GET",
      dataType:"json",
      data: { 'target_id' : selected_target },
      url: "/admin/upgrade_ticket_items/select_inventory",
      success: function(response){
        var origin_variants = response.origin_variants;
        var originvariant_ids = []

        if ($('[id="last_target_origin_ids_"]').length != 0) {
          $('[id="last_target_origin_ids_"]').each(function() {
            originvariant_ids.push($(this).val())
          })
        }

        $("#tmp_origin_variant_ids option").remove();
        $.each(origin_variants, function(_key, data) {
          let option = $("<option></option>");
              option.attr("value", data[1]);
              option.text(`${data[0]}`);

          $('#tmp_origin_variant_ids').append(option);
        })

        if (origin_variant_ids != undefined) {
          var origin_ids = origin_variant_ids.split(' ')
          $('#tmp_origin_variant_ids').val(origin_ids)

          $('#tmp_origin_variant_ids').change(function() {
            // $('.price-list').remove()
            changeTargetOrigin(originvariant_ids)
            datePickerForm()
          }).change()
        }

        $('.alert.alert-success').remove()
      }
    });
  }

  $('#tmp_origin_variant_ids').change(function() {
    // $('.price-list').remove()
    var originvariant_ids = []

    if ($('[id="last_target_origin_ids_"]').length != 0) {
      $('[id="last_target_origin_ids_"]').each(function() {
        originvariant_ids.push($(this).val())
      })
    }

    changeTargetOrigin(originvariant_ids)
  }).change()

  function changeTargetOrigin(originvariant_ids) {
    $.each($('#tmp_origin_variant_ids').find('option:selected'), function( index, option ) {
      // console.log(option)
      var value          = option.value
      var text           = option.text
      // console.log(value)
      var price          = $(`#price-variant-${value}`).val()
      var quantity       = $(`#quantity-variant-${value}`).val()
      var val_sale_start = $(`#sale-start-${value}`).val()
      var val_sale_end   = $(`#sale-end-${value}`).val()
      var sale_start     = val_sale_start != undefined ? val_sale_start : ''
      var sale_end       = val_sale_end != undefined ? val_sale_end : ''

      if (!$(`#price-${value}`).attr('class')) {
        addPriceForm(value, text, price, quantity, sale_start, sale_end, originvariant_ids)
      }
    });
  }

  function addPriceForm(value, text, price, quantity, sale_start, sale_end, origin_variant_ids) {
    var form_price = `<div class="row mb-3">`+
                      `<div class="col-md-12 col-12"><b>${text}</b></div>`+
                     `</div>`+
                     `<div class="row">`+
                      `<div class="col-md-6 col-12 mb-3">`+
                       `<label for="sell_start">`+
                        I18n.t('global.sale_start') + ` <span class="text-danger">*</span>`+
                       `</label>`+
                        `<input type="text" name="[${value}][inventory_stock_attributes][sale_start]" id="" value="${sale_start}" class="form-control sale-start-form-${value}" required="required" autocomplete="off">`+
                      `</div>`+
                      `<div class="col-md-6 col-12 mb-3">`+
                        `<label for="sell_end">`+
                          I18n.t('global.sale_end') + ` <span class="text-danger">*</span>`+
                        `</label>`+
                        `<input type="text" name="[${value}][inventory_stock_attributes][sale_end]" id="" value="${sale_end}" class="form-control sale-end-form-${value}" required="required" autocomplete="off">`+
                      `</div>`+
                     `</div>`+
                      `<div class="row">`+
                       `<div class="col-md-3 col-12 row quantity-${value} mb-3">`+
                        `<div class="col-md-8 pr-0">`+
                          `<label for="quantity">`+
                            I18n.t('inventories.quantity') + ` <span class="text-danger">*</span>`+
                          `</label>`+
                          `<input type="number" name="[${value}][inventory_stock_attributes][quantity]" id="quantity-${value}" value="${quantity}" class="form-control input-sm" required="required">`+
                        `</div> `+
                        `<div class="col-md-4 pl-0">`+
                           `<span id="update-qty-text-${value}"></span>`+
                        `</div>`+
                       `</div>`+
                       `<div class="col-md-9 col-12 price-${value}">`+
                        `<label for="quantity">`+
                         I18n.t('inventories.price') + `<span class="text-danger">*</span>`+
                        `</label>`+
                        `<input type="number" name="[${value}][inventory_stock_attributes][price]" id="price-${value}" value="${price}" class="form-control" required="required">`+
                       `</div>`+
                     `</div>`;


    $('.price-variants').append(form_price)
    if (origin_variant_ids.includes(`${value}`)) {
      $(`#quantity-${value}`).attr('disabled', true)
    } else {
      $(`#quantity-${value}`).removeAttr('disabled')
    }
    plusMinusQuantity(value, origin_variant_ids)
  }

  function plusMinusQuantity(value, origin_variant_ids) {
    var plus_minus_quantity = `<div class="mb-3">`+
                                `<button type="button" class="btn btn-secondary plus_minus_quantity" data-toggle="modal"
                                         data-target="#exampleModal-${value}" data-quantity="Plus Quantity"
                                         data-stock-id="${value}" data-type="plus">` +
                                `+` +
                                `</button>`+
                                `<button type="button" class="btn btn-secondary plus_minus_quantity ml-2" data-toggle="modal"
                                         data-target="#exampleModal-${value}" data-quantity="Minus Quantity"
                                         data-stock-id="${value}" data-type="minus">`+
                                `-` +
                                `</button>`+
                              `</div>`;
    if (origin_variant_ids.includes(`${value}`)) {
      $('.price-variants').append(plus_minus_quantity)
    }
  }

  function datePickerForm() {
    $.each($('#tmp_origin_variant_ids').find('option:selected'), function( index, option ) {
      var value    = option.value

      $(`.sale-start-form-${value}, .sale-end-form-${value}`).bootstrapDP({
          autoclose: true,
          format: "dd/mm/yyyy",
          todayHighlight: true,
          orientation: "bottom",
          language: I18n.locale
      });
    });
  }

  if ($('[id="last_target_origin_ids_"]').length != 0) {
    $('[id="last_target_origin_ids_"]').each(function() {
      var target_origin_id = $(this).val()

      $(`#plus-qty-${target_origin_id}`).keyup(function() {
        $(`#plus-quantity-${target_origin_id}`).val($(this).val())
      })

      $(`#minus-qty-${target_origin_id}`).keyup(function() {
        $(`#minus-quantity-${target_origin_id}`).val($(this).val())
      })
    })
  }
});